import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d011875"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-input-address" }
const _hoisted_2 = {
  key: 0,
  class: "base-input-address__dadata-items"
}
const _hoisted_3 = ["onClick"]

import { ref, Ref } from 'vue';
import { getAddress, getLocation } from '@/api/ymaps';
import { StylesType } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAddressInput',
  props: /*#__PURE__*/_mergeModels({
    height: { default: '36' },
    label: {},
    type: {},
    hideArrows: { type: Boolean },
    filled: { type: Boolean },
    styles: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: /*#__PURE__*/_mergeModels(['changeLocation'], ["update:modelValue"]),
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
// eslint-disable-next-line no-undef
const inputValue = _useModel<string | number | undefined | null>(__props, "modelValue");

const addressItems: Ref<string[]> = ref([]);
const showAddressItems: Ref<boolean> = ref(false);
const clickOutside = () => {
  if (showAddressItems.value) {
    showAddressItems.value = false;
  }
};

const updateAddress = (event: string) => {
  if (event) {
    getAddress(event).then(res => {
      addressItems.value = res.data.suggestions.map((el: { value: string }) => el.value);
      if (addressItems.value.length > 0) {
        showAddressItems.value = true;
      }
    });
  }
};

const changeLocation = (value: string) => {
  getLocation(value).then(res => {
    const point =
      res.data.response.GeoObjectCollection.featureMember[0].GeoObject.Point.pos.split(
        ' ',
      );

    emit('changeLocation', point);
  });
  showAddressItems.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_input, {
      modelValue: inputValue.value,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        updateAddress
      ],
      filled: _ctx.filled,
      height: _ctx.height,
      hideArrows: _ctx.hideArrows,
      label: _ctx.label,
      styles: _ctx.styles,
      type: _ctx.type
    }, null, 8, ["modelValue", "filled", "height", "hideArrows", "label", "styles", "type"]),
    (showAddressItems.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(addressItems.value, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              class: "base-input-address__dadata-items-item",
              onClick: _withModifiers(($event: any) => {
          changeLocation(item);
          inputValue.value = item;
        }, ["prevent"])
            }, _toDisplayString(item), 9, _hoisted_3))
          }), 256))
        ]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_click_outside, clickOutside]
  ])
}
}

})